import React from "react";

// Importing the Tr component for rendering each row
import Tr from "./Tr";

// The main Table component which displays data in a tabular format
export default function Table({ data, onEdit, onDelete }) {
  return (
    <div className="form-container">
      {/* Table structure with headers for the data fields */}
      <table className="table">
        <thead>
          <tr>
            {/* Column headers */}
            <th className="ps-5">Rarity Type</th>
            <th className="col-numeric-date">Rarity On</th>
            <th className="col-numeric-date">Starts On</th>
            <th className="col-numeric-date">Ends On</th>
            <th className="col-numeric-date">Max Count</th>
            <th className="col-numeric-date">Status</th>
            <th className="col-options">Options</th>
          </tr>
        </thead>

        <tbody>
          {/* Check if data is empty */}
          {data.length === 0 ? (
            // If no data, show a single row with a message
            <tr>
              <td colSpan={5}>No data found....</td>
            </tr>
          ) : (
            // Map through data and render each row using the Tr component
            data.map((d, index) => (
              <Tr
                key={index}                    // Unique key for each row
                id={d.rarity_id}               // Unique ID for the rarity item
                status={d.status}              // Status of the item
                id_of_type={d.id_of_type}      // Additional identifier for item type
                rarity_type={d.rarity_type}    // Type of rarity
                starts_on={d.starts_on}        // Start date of rarity
                ends_on={d.ends_on}            // End date of rarity
                max_count={d.max_count}        // Maximum count allowed
                onEdit={onEdit}                // Function to edit the row
                onDelete={onDelete}            // Function to delete the row
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
